export const pricingData = {
    coupesEco: {
        title: "COUPES ECO",
        data: {
            femme:[
                {
                    prestation: ["Shampoing normal + Coupe + Séchage"],
                    variations: [
                        {details: "Très courts (oreille dégagée)", prix: "35€", duree: "20min"},
                        {details: "Courts", prix: "40€", duree: "30min"}
                    ]
                }
            ],
            homme: [
                {
                    prestation: ["Shampoing normal + Coupe + Séchage"],
                    variations: [{ details: "Très courts (oreille dégagée)", prix: "23€", duree: "15min" }]
                }
            ]
        }
    },
    coupesPremium: {
        title: "COUPES PREMIUM",
        data: {
            homme: [
            {
                prestation: ["Shampoing normal + Coupe + Séchage"],
                variations: [{ details: "Très courts", prix: "29€", duree: "20min" }]
            },
            {
                prestation: ["Shampoing normal + Coupe aux ciseaux + Séchage"],
                variations: [
                { details: "Courts", prix: "33€", duree: "25min" },
                { details: "Mi-longs (dessus épaule)", prix: "40€", duree: "30min" }
                ]
            },
            {
                prestation: ["Shampoing normal + Brushing"],
                variations: [{ details: "Très courts", prix: "18€", duree: "15min" }]
            }
            ],
            femme: [
            {
                prestation: ["Shampoing normal + Coupe + Brushing"],
                variations: [
                { details: "Courts", prix: "40€", duree: "30min" },
                { details: "Mi-longs (dessus épaules)", prix: "44€", duree: "45min" },
                { details: "Longs (niveau omoplates)", prix: "49€", duree: "60min" },
                { details: "Très longs", prix: "55€", duree: "90min" }
                ]
            },
            {
                prestation: ["Shampoing normal + Brushing"],
                variations: [
                { details: "Courts", prix: "25€", duree: "15min" },
                { details: "Mi-longs (dessus épaules)", prix: "28€", duree: "30min" },
                { details: "Longs (niveau omoplates)", prix: "32€", duree: "45min" },
                { details: "Très longs", prix: "40€", duree: "75min" }
                ]
            }
            ],
            enfant: [
            {
                prestation: ["Shampoing normal + Coupe + Coiffure (9 à 18 ans)"],
                variations: [
                { details: "Garçons", prix: "25€", duree: "30min" },
                { details: "Filles", prix: "36€", duree: "30min" }
                ]
            },
            {
                prestation: ["Coupe + Coiffure (- de 9 ans)"],
                variations: [
                { details: "Garçons", prix: "20€", duree: "15min" },
                { details: "Filles", prix: "26€", duree: "15min" }
                ]
            }
            ]
        }
    },
    coupesTechniques: {
    title: "PRESTATIONS TECHNIQUES",
    data: {
        femme: [
        {
            prestation: [
                "Couleur racines (jusqu'à 2cm)",
                "Couleur INOA (jusqu'à 2cm)",
                "Mèches / Balayage",
                "Décoloration",
                "Permanente ou mini-vague",
                "Shampoing spécifique",
                "Soin masque",
                "Lissage brésilien",
                "Défrisage X-TENSO"
            ],
            variations: [
                {prix: "33€"},
                {prix:"45€"},
                {prix:"à partir de 40€"},
                {prix:"à partir de 35€"},
                {prix:"à partir de 40€"},
                {prix:"5€"},
                {prix:"à partir de 10€"},
                {prix:"Nous consulter"},
                {prix:"Nous consulter"}
            ]
        }
        ],
        homme: [
        {
            prestation: ["Couleur", "Permanente ou mini-vague", "Taille barbe"],
            variations: [
                {prix: "23€"},
                {prix: "à partir de 40€"},
                {prix: "15€"}
            ]
        }
        ]
    }
    }
};